module.exports = __webpack_public_path__ + "static/media/AIclearPath.277a9fb4.webp";